// @ts-check

const createScript = id => {
    const $fragment = document.createDocumentFragment();

    const $script = document.createElement("script");

    $script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${id}');
        fbq('track', 'PageView');
    `;

    const $pixel = document.createElement("noscript");
    const $image = document.createElement("img");

    $image.width = 1;
    $image.height = 1;
    $image.style.display = "none";
    $image.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`;

    $pixel.appendChild($image);

    $fragment.appendChild($script);
    $fragment.appendChild($pixel);

    return $fragment;
};

export default createScript;
